import Container from "./container";
import { MdOutlineDesignServices } from "react-icons/md";
import { TbBuildingBank } from "react-icons/tb";
// import { AiOutlineProduct } from "react-icons/ai";
import { CiDeliveryTruck } from "react-icons/ci";
import { GiAutoRepair } from "react-icons/gi";
import { MdOutlinePrecisionManufacturing } from "react-icons/md";
import SectionTitle from "./section-title";
export const WorkingProcess = () => {
  const steps = [
    {
      id: 1,
      title: "Design Consultation",
      description:
        "Enjoy a free site survey and consultation on design and materials.",
      icon: MdOutlineDesignServices,
    },
    {
      id: 2,
      title: "Space Planning and Visualization",
      description:
        "Receive detailed 2D AutoCAD drawings and a cost estimate for your project.",
      icon: TbBuildingBank,
    },
    {
      id: 3,
      title: "Custom Furniture Production",
      description:
        "We handle everything from furniture design and production to fitting.",
      icon: MdOutlinePrecisionManufacturing,
    },
    {
      id: 4,
      title: "Delivery and Installation",
      description:
        "Our team ensures prompt delivery and professional installation.",
      icon: CiDeliveryTruck,
    },
    {
      id: 5,
      title: "After-Sales Service",
      description:
        "We provide ongoing support and service to ensure your complete satisfaction.",
      icon: GiAutoRepair,
    },
  ];
  //
  return (
    <Container className="container mx-auto px-4 py-16 space-y-10 md:space-y-16 ">
      <h2 className="text-2xl md:text-3xl font-bold text-center mb-4 text-gray-800">
        OUR WORKING PROCESS
      </h2>
      {/* <SectionTitle title="OUR WORKING PROCESS" /> */}

      {/* <p className="text-center text-gray-600 mb-16 max-w-2xl mx-auto">
        We've distilled our interior design process into 4 Steps – the same
        steps we have been using for more than 41 years. In these steps, the
        designer visits your home to gather more information.
      </p> */}
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-8 md:gap-14">
        {steps.map((step) => {
          const Icon = step.icon;
          return (
            <div
              key={step.id}
              className={`flex flex-col items-center max-w-xs`}
            >
              <div
                className={`w-10 aspect-square md:w-20 rounded-full flex items-center justify-center mb-6 relative 
                bg-gray-50
             `}
              >
                <Icon
                  className={`w-8 h-8 md:w-12 md:h-12 ${"text-gray-400"}`}
                />
                <div className="absolute -top-2 -left-2 w-4 h-4 aspect-square md:w-6 md:h-6 rounded-full bg-[#e60000] flex items-center justify-center text-white font-bold  text-[10px]">
                  {step.id}
                </div>
              </div>
              <div className="text-center">
                <h3 className="font-semibold text-base md:text-xl mb-3 text-gray-800">
                  {step.title}
                </h3>
                <p className="text-sm text-gray-600">{step.description}</p>
              </div>
            </div>
          );
        })}
        {/* <div className="absolute top-1/2 left-0 right-0 h-0.5 bg-amber-200 -z-10 hidden md:block" /> */}
      </div>
    </Container>
  );
};

export default WorkingProcess;
